import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { Avatar as AvatarUi } from 'ui/avatar';
import { Divider } from 'ui/divider';
import { InputText } from 'ui/inputs';
import { LinkButton } from 'ui/linkButton';
import { Caption, Subtitle1, Subtitle2, duration, easing, spacing, colors, Body2 } from 'ui/theme';

export const LinksWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${spacing.base};
`;

export const StyledLinkButton = styled(LinkButton)`
  gap: ${spacing.half};
`;

export const ProfileWrapper = styled.div`
  background-color: ${colors.backgroundSecondary};
  padding: ${spacing.base};
  border-bottom: solid ${spacing.single} ${colors.borderPrimarySubtle};
`;

export const ProfileLink = styled(NavLink)`
  align-items: center;
  display: grid;
  column-gap: ${spacing.half};
  row-gap: ${spacing.eighth};
  grid-template-columns: ${`${spacing.double} 1fr ${spacing.double}`};
  grid-template-rows: auto auto;
  grid-template-areas: 'avatar name icon' 'avatar email icon';
  padding: ${spacing.quarter} ${spacing.quarter} ${spacing.quarter} ${spacing.half};
  color: ${colors.textSecondary};
  border-radius: ${spacing.half};
  transition: background-color ${duration.short} ${easing.standard};

  &:hover {
    color: ${colors.textPrimary};
    background-color: ${colors.backgroundPrimaryHover};
  }
`;

export const IconWrapper = styled.span`
  grid-area: icon;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const FlexContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: ${spacing.half};
`;

export const ProjectsHeading = styled(Subtitle1)`
  margin: 0;
`;

export const ProjectsHeader = styled.div`
  background-color: ${colors.backgroundPrimary};
  padding: ${spacing.plusHalf} ${spacing.plusHalf} 0;
  margin-bottom: ${spacing.quarter};
`;

export const ListContainer = styled.div`
  flex-grow: 1;
  overflow: hidden;
`;

export const ProjectsList = styled.div`
  background-color: ${colors.backgroundPrimary};
  min-height: 100%;
  max-height: 100%;
  overflow-y: auto;
  padding: ${spacing.half} ${spacing.plusHalf};
  display: flex;
  flex-direction: column;
  gap: ${spacing.quarter};
`;

export const SearchInput = styled(InputText)``;

export const Avatar = styled(AvatarUi)`
  grid-area: avatar;
`;

export const FullName = styled(Subtitle2)`
  grid-area: name;
  margin: 0;
`;

export const Email = styled(Caption)`
  grid-area: email;
  color: inherit;
`;

export const StyledDivider = styled(Divider)`
  width: 100%;
  margin-top: ${spacing.half};
  margin-bottom: ${spacing.half};
`;

export const EmptyStateMessage = styled(Body2)`
  padding: ${spacing.half};
  color: ${colors.textSecondary};
`;
